/* eslint-disable comma-dangle */
/* eslint-disable quotes */

import { LlmTheme } from "@websolutespa/bom-mixer-llm";

export const theme: LlmTheme = {
  "mode": "chat",
  "scale": 1,
  "font": {
    "source": "<link href=\"https://design.wslabs.it/llm/fonts/kinney.css\" rel=\"stylesheet\"><link href=\"https://design.wslabs.it/llm/fonts/bliss2.css\" rel=\"stylesheet\">",
    "primary": "'kinney', sans-serif",
    "secondary": "'bliss2', sans-serif"
  },
  "typography": {
    "display1": {
      "fontWeight": "500",
      "lineHeight": "1.1",
      "letterSpacing": "0.02em",
      "fontSizeMin": "32",
      "fontSizeMax": "72"
    },
    "display2": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "fontSizeMin": "32",
      "fontSizeMax": "76"
    },
    "display3": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.02em",
      "fontSizeMin": "24",
      "fontSizeMax": "56"
    },
    "display4": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.02em",
      "fontSizeMin": "24",
      "fontSizeMax": "48"
    },
    "display5": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.02em",
      "fontSizeMin": "24",
      "fontSizeMax": "40"
    },
    "display6": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.02em",
      "fontSizeMin": "16",
      "fontSizeMax": "32"
    },
    "heading1": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.02em",
      "fontSizeMin": "18",
      "fontSizeMax": "32"
    },
    "heading2": {
      "fontWeight": "500",
      "lineHeight": "1.3",
      "letterSpacing": "0.03em",
      "fontSizeMin": "16",
      "fontSizeMax": "24"
    },
    "body1": {
      "fontWeight": "normal",
      "lineHeight": "1.4",
      "letterSpacing": "0",
      "fontSizeMin": "16",
      "fontSizeMax": "24"
    },
    "body2": {
      "fontWeight": "500",
      "lineHeight": "1.4",
      "letterSpacing": "0",
      "fontSizeMin": "16",
      "fontSizeMax": "18"
    },
    "body3": {
      "fontWeight": "normal",
      "lineHeight": "1.4",
      "letterSpacing": "0",
      "fontSizeMin": "14",
      "fontSizeMax": "18"
    },
    "body4": {
      "fontWeight": "500",
      "lineHeight": "1.5",
      "letterSpacing": "0",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "body5": {
      "fontWeight": "normal",
      "lineHeight": "1.5",
      "letterSpacing": "0",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "label1": {
      "fontWeight": "500",
      "lineHeight": "1",
      "letterSpacing": "0.08em",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "cta1": {
      "fontWeight": "500",
      "lineHeight": "1",
      "letterSpacing": "0.08em",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "cta2": {
      "fontWeight": "700",
      "lineHeight": "1.2",
      "letterSpacing": "0.02em",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "cta3": {
      "fontWeight": "500",
      "lineHeight": "1",
      "letterSpacing": "0.06em",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    },
    "cta4": {
      "fontWeight": "500",
      "lineHeight": "1.2",
      "letterSpacing": "0.02em",
      "fontSizeMin": "14",
      "fontSizeMax": "16"
    }
  },
  "color": {
    "neutral": {
      "100": "#f4f2f2",
      "200": "#c7c4c1",
      "300": "#a6a39e",
      "400": "#8d8882",
      "500": "#857f7a",
      "600": "#6c6662",
      "700": "#585350",
      "800": "#4c4847",
      "900": "#252323"
    },
    "base": {
      "100": "#eff9ff",
      "200": "#b6e6ff",
      "300": "#75d5ff",
      "400": "#2cc0ff",
      "500": "#00aeff",
      "600": "#0086d4",
      "700": "#006bab",
      "800": "#005a8d",
      "900": "#042f4d",
    },
    "blob": {
      "100": "var(--llm-color-neutral-900)",
      "200": "var(--llm-color-base-200)",
      "300": "var(--llm-color-neutral-900)",
      "400": "var(--llm-color-base-500)",
      "500": "var(--llm-color-neutral-900)",
      "600": "var(--llm-color-base-700)",
    },
    "custom": {
      "white": "#ffffff",
      "offwhite": "#F8F2E8",
      "blue": "#003A6B",
      "ciano": "#0085CA",
      "yellow": "#FFD300",
    },
    "background": "var(--llm-color-neutral-100)",
    "foreground": "var(--llm-color-neutral-800)",
    "outline": "var(--llm-color-neutral-900)",
    "title": {
      "background": "var(--llm-color-background)",
      "foreground": "var(--llm-color-foreground)"
    },
    "primary": {
      "background": "var(--llm-color-base-500)",
      "foreground": "var(--llm-color-neutral-100)"
    },
    "secondary": {
      "background": "var(--llm-color-base-500)",
      "foreground": "var(--llm-color-neutral-100)"
    },
    "accent": {
      "background": "transparent",
      "foreground": "var(--llm-color-base-500)"
    },
    "success": "#7dc18a",
    "warning": "#ff9800",
    "error": "#ff4848"
  },
  "border": "1px solid var(--llm-color-neutral-300)",
  "trigger": {
    "position": "bottom",
    "size": "60px",
    "background": "var(--llm-color-neutral-900)",
    "foreground": "var(--llm-color-base-500)",
    "boxShadow": "var(--llm-shadow-md)"
  },
  "chat": {
    "top": "auto",
    "right": "20px",
    "bottom": "20px",
    "left": "auto",
    "maxWidth": "Min(calc(100vw - 40px), 1024px)",
    "maxHeight": "calc(100vh - 100px)",
    "borderRadius": "8px",
    "boxShadow": "var(--llm-shadow-sm)"
  },
  "main": {
    "background": "var(--llm-color-background)",
    "foreground": "var(--llm-color-foreground)"
  },
  "canvas": {
    "opacity": 1,
    "enabled": false
  },
  "popup": {
    "maxWidth": "210px",
    "background": "var(--llm-color-title-background)",
    "foreground": "var(--llm-color-title-foreground)",
    "border": "none"
  },
  "triggerCta": {
    "background": "var(--llm-color-neutral-900)",
    "foreground": "var(--llm-color-base-500)"
  },
  "hint": {
    "fontFamily": "var(--llm-font-primary)",
    "background": "var(--llm-color-background)",
    "foreground": "var(--llm-color-foreground)",
    "border": "1px solid var(--llm-color-neutral-300)",
    "borderRadius": "12px",
    "boxShadow": "none"
  },
  "hintTitle": {
    "flexDirection": "row",
    "color": "var(--llm-color-foreground)"
  },
  "hintIcon": {
    "width": "18px",
    "height": "18px",
    "color": "var(--llm-color-foreground)"
  },
  "pill": {
    "padding": "8px",
    "fontFamily": "var(--llm-font-primary)",
    "background": "var(--llm-color-title-background)",
    "foreground": "var(--llm-color-title-foreground)",
    "border": "1px solid var(--llm-color-neutral-300)",
    "borderRadius": "5px"
  },
  "input": {
    "fontFamily": "var(--llm-font-secondary)",
    "background": "var(--llm-color-background)",
    "foreground": "var(--llm-color-foreground)",
    "accent": "var(--llm-color-foreground)",
    "borderRadius": "8px"
  },
  "promptSubmit": {
    "background": "var(--llm-color-neutral-900)",
    "foreground": "var(--llm-color-neutral-100)"
  },
  "scrollProposition": {
    "size": "32px",
    "borderRadius": "16px",
    "background": "var(--llm-color-neutral-100)",
    "foreground": "var(--llm-color-neutral-900)",
    "boxShadow": "0 6px 8px -4px rgba(0, 0, 0, 0.5)"
  },
  "checkbox": {
    "border": "1px solid var(--llm-color-neutral-300)"
  },
  "user": {
    "background": "linear-gradient(rgba(154, 154, 154, 0.2) 10%, rgba(221, 221, 221, 0.1) 80%)",
    "foreground": "var(--llm-color-title-foreground)",
    "border": "1px solid var(--llm-color-neutral-300)"
  },
  "assistant": {
    "background": "none",
    "foreground": "var(--llm-color-foreground)",
    "border": "none"
  },
  "markdown": {
    "marginTop": "0.5rem",
    "marginBottom": "1rem",
    "marginLeft": "1rem",
    "accent": "var(--llm-color-base-500)",
    "border": "1px solid var(--llm-color-neutral-300)"
  },
  "event": {
    "background": "var(--llm-color-base-100)",
    "foreground": "var(--llm-color-foreground)"
  },
  "card": {
    "background": "var(--llm-color-neutral-100)",
    "foreground": "var(--llm-color-neutral-900)",
    "aspectRatio": "240 / 165"
  },
  "cardVideo": {
    "aspectRatio": "16 / 9"
  },
  "product": {
    "border": "var(--llm-color-neutral-200)",
    "background": "var(--llm-color-neutral-100)",
    "foreground": "var(--llm-color-neutral-900)",
    "available": "var(--llm-color-success)",
    "soldout": "var(--llm-color-error)",
    "aspectRatio": "1 / 1"
  },
  "productLabel": {
    "background": "var(--llm-color-neutral-100)",
    "foreground": "var(--llm-color-neutral-900)"
  },
  "shadow": {
    "xs": "0 2px 20px -2px rgba(0, 0, 0, 0.1)",
    "sm": "0 4px 30px -4px rgba(0, 0, 0, 0.2)",
    "md": "0 6px 40px -6px rgba(0, 0, 0, 0.4)",
    "lg": "0 8px 50px -8px rgba(0, 0, 0, 0.6)",
    "xl": "0 10px 60px -10px rgba(0, 0, 0, 0.8)"
  },
  "headerCta": {
    "fontSize": "18px",
    "padding": "0.5em 1em",
    "borderRadius": "2em",
    "background": "var(--llm-color-primary-background)",
    "foreground": "var(--llm-color-primary-foreground)"
  },
  "feedback": {
    "type": "stars",
    "size": "1rem",
    "gap": "12px",
    "padding": "4px",
    "border": "1px solid var(--llm-color-neutral-300)"
  }
};
